import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";
import Indexpage from './components/Indexpage';
import Contact from './components/Contact';
import Aboutuspage from './components/Aboutuspage';
import Officecleaning from './components/Officecleaning';
import Ourservices from './components/Ourservices';
import Navbar from './components/Navbar';
import Glasscleaning from './components/Glasscleaning';
import Fasadacleaning from './components/Fasadacleaning';
import Staircasecleaning from './components/Staircasecleaning';
import Practicecleaning from './components/Practicecleaning';
import Apartmentcleaning from './components/Apartmentcleaning';
import Constructioncleaning from './components/Constructioncleaning';
import Gallerypage from './components/Gallerypage';
import Movecleaning from './components/Movecleaning';
import Highpressurecleaning from './components/Highpressurecleaning';
import Cleaningform from './components/Cleaningform';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route index element={<Indexpage />} />
        <Route path="/kontakt" exact element={<Contact />} />
        <Route path="/uberuns" exact element={<Aboutuspage />} />
        <Route path="/büroreinigung" element={<Officecleaning/>} />
        <Route path='/glasundfensterreinigung' element={<Glasscleaning/>} />
        <Route path='/fassadenreinigung' element={<Fasadacleaning />} />
        <Route path='/treppenhausreinigung' element={<Staircasecleaning />} />
        <Route path='/praxisreinigung' element={<Practicecleaning />} />
        <Route path='/wohnungsreinigung' element={<Apartmentcleaning />} />
        <Route path='/bauabschlussreinigung' element={<Constructioncleaning />} />
        <Route path='/umzugsreinigung' element={<Movecleaning />} />
        <Route path='/hochdruckreinigung' element={<Highpressurecleaning />} />
        <Route path='/galerieseite' element={<Gallerypage />} />
        <Route path="/dienstleistungen" element={<Ourservices/>} />
        <Route path="/angebotanforden" element={<Cleaningform />} />
      </Routes>
    </Router>
  );
}

export default App;
